import { render, staticRenderFns } from "./NationalQualification.vue?vue&type=template&id=88755454&scoped=true&"
import script from "./NationalQualification.vue?vue&type=script&lang=js&"
export * from "./NationalQualification.vue?vue&type=script&lang=js&"
import style0 from "./NationalQualification.vue?vue&type=style&index=0&id=88755454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88755454",
  null
  
)

export default component.exports